import React from "react";

const BookIcon = ({ color = "#1F5DBB", size = 18, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_248_238)">
        <path
          d="M15 16.4999V3.74992C15 2.50942 13.9905 1.49992 12.75 1.49992H11.8575C11.7225 1.11967 11.4975 0.773916 11.1765 0.510666C10.6538 0.0816661 9.9735 -0.0863339 9.309 0.0441661L4.80825 0.944166C3.7605 1.15417 3 2.08267 3 3.14992V16.4999H0V17.9999H18V16.4999H15ZM9.375 9.93742C8.754 9.93742 8.25 9.43342 8.25 8.81242C8.25 8.19142 8.754 7.68742 9.375 7.68742C9.996 7.68742 10.5 8.19142 10.5 8.81242C10.5 9.43342 9.996 9.93742 9.375 9.93742ZM13.5 16.4999H12V2.99992H12.75C13.1632 2.99992 13.5 3.33592 13.5 3.74992V16.4999Z"
          fill={color}
        />
        <path
          d="M15 16.4999V3.74992C15 2.50942 13.9905 1.49992 12.75 1.49992H11.8575C11.7225 1.11967 11.4975 0.773916 11.1765 0.510666C10.6538 0.0816661 9.9735 -0.0863339 9.309 0.0441661L4.80825 0.944166C3.7605 1.15417 3 2.08267 3 3.14992V16.4999H0V17.9999H18V16.4999H15ZM9.375 9.93742C8.754 9.93742 8.25 9.43342 8.25 8.81242C8.25 8.19142 8.754 7.68742 9.375 7.68742C9.996 7.68742 10.5 8.19142 10.5 8.81242C10.5 9.43342 9.996 9.93742 9.375 9.93742ZM13.5 16.4999H12V2.99992H12.75C13.1632 2.99992 13.5 3.33592 13.5 3.74992V16.4999Z"
          fill="black"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_248_238">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BookIcon;
